import Sheet from '@mui/joy/Sheet'
import Tooltip from '@mui/joy/Tooltip'
import Typography from '@mui/joy/Typography'
import { type FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'

import CreditsIcon from 'ASSETS/img/credits.svg?react'

import { formatCompactCredits } from '../../../utils/formatCompactCredits'

const LINK_STYLE = { textDecoration: 'none' } as const

const SX_TILE = {
  width: 32,
  py: 0.75,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 0.25,
  borderRadius: 'md',
  color: 'primary.plainColor',
} as const

const CreditBalanceBadge: FC<{ balance: number }> = ({ balance }) => {
  const { t } = useTranslation()
  const label = t('nav.credits')

  return (
    <Tooltip title={label} placement="right" arrow>
      <RouterLink to="/settings" aria-label={label} style={LINK_STYLE}>
        <Sheet variant="outlined" sx={SX_TILE}>
          <CreditsIcon aria-hidden="true" width={20} height={20} />
          <Typography level="body-xs" fontWeight="lg" textColor="text.primary">
            {formatCompactCredits(balance)}
          </Typography>
        </Sheet>
      </RouterLink>
    </Tooltip>
  )
}

export default CreditBalanceBadge
